import React, { useEffect } from "react";

const MediaViewer = ({children}) => {
    const [zoomed, setZoomed] = React.useState(false);
    const handleEscapeKeyPress = (event) => {
        if (event.key === 'Escape') {
            setZoomed(false);
        }
    };
      
    useEffect(() => {
        const handleKeyPress = (event) => {
            handleEscapeKeyPress(event);
        };
      
        document.addEventListener('keydown', handleKeyPress);
      
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    return <><div className={"viewer " + (zoomed && " zoom")} onClick={() => setZoomed(!zoomed)}>
        <div className="outer">
            {zoomed && <div className="button"><span className="material-symbols-rounded">close</span></div>}
            <div className="container">
                {children}
            </div>
        </div>
    </div>
    <style jsx>
        {`
            .viewer {
                cursor: zoom-in;
            }
            .viewer:not(.zoom):hover {
                opacity: 0.8;
            }
            .viewer.zoom {
                position: fixed;
                top: 122px;
                bottom: 0;
                left: 0;
                right: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 399;
                cursor: zoom-out;
            }

            .outer {
                position: relative;
            }

            .button {
                border-top: 1px solid var(--code-border);
                position: absolute;
                right: -36px;
                background: white;
                z-index: 899;
                display: flex;
                box-shadow: 0px 2px 0px 1px var(--code-border);
                border-radius: var(--border-radius);
                padding: 3px;
            }

            .button:hover {
                background: var(--code-border);
            }

            .zoom .container {
                border: 1px solid var(--code-border);
                border-radius: calc(var(--border-radius) * 2);
                overflow: auto;
                box-shadow: 0px 0px 100px -50px;
                max-height: 70vh;
                max-width: 90vw;
                width: max-content;
                height: auto;
                background: var(--gray-medium);
            }

            .zoom:before{
                content: "";
                background: black;
                position: absolute;
                top: 0px;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: -1;
                opacity: 0.3;
            }
        `}
    </style></>;
};

export { MediaViewer };